import "./Successors.scss";
import React from "react";
import ShieldSVG from "assets/svg/ShieldSVG";
import UserGroupSVG from "assets/svg/UsersGroupSVG";
import FilesSVG from "assets/svg/FilesSVG";
import TicketSVG from "assets/svg/TicketSVG";
import SuccessorsFractalSVG from "assets/svg/SuccessorsFractalSVG";

export type ParentType = "payment" | "homepage";

const AvailablePackages: React.FC = () => {
  const cards = [
    {
      icon: <ShieldSVG />,
      heading: "Bezpieczeństwo i kontrola",
      paragraph:
        "Dane są przechowywane w aplikacji, a dostęp do nich możliwy tylko po spełnieniu odpowiednich warunków.",
    },
    {
      icon: <UserGroupSVG />,
      heading: "Spokój i przewidywalność",
      paragraph: "Możliwość samodzielnego wyznaczenia sukcesorów jeszcze dziś.",
    },
    {
      icon: <FilesSVG />,
      heading: "Wygodne dodawanie plików i instrukcji",
      paragraph: "Dokumenty można uzupełniać samodzielnie i bez opłat.",
    },
    {
      icon: <TicketSVG />,
      heading: "Bezpłatny dostęp do zakładki",
      paragraph:
        "Dodawanie dokumentów i plików jest całkowicie bezpłatne. Opłata pojawia się wyłącznie w momencie wskazania sukcesorów: pierwszy sukcesor – 199 zł, każdy kolejny – 99 zł.",
    },
  ];

  return (
    <section className="successors">
      <div className="layout">
        {/* <div className="successors__soon">
          <div className="successors__soon-label">FUNKCJA DOSTĘPNA WKRÓTCE</div>
        </div> */}
        <div className="successors__header">
          <h2>
            Nieprzewidziane sytuacje, przewidziane rozwiązanie – <i>Sukcesja</i>
          </h2>
          <p>
            W zakładce <strong>„Sukcesja”</strong> można w uporządkowany i
            bezpieczny sposób przekazać ważne informacje oraz dokumenty na
            wypadek śmierci lub utraty zdolności do działania. <br />
            <br />
            To przestrzeń do przechowywania kluczowych plików, takich jak
            testament, akt własności, pełnomocnictwa czy inne dokumenty
            dotyczące spraw osobistych lub majątkowych. Użytkownik może wskazać
            osoby, które – po spełnieniu odpowiednich procedur weryfikacyjnych –
            uzyskają dostęp do wybranych materiałów.
          </p>
        </div>
        <div className="successors__list">
          {cards.map((card, index) => (
            <div className="successors__item" key={index}>
              <div className="successors__icon">{card.icon}</div>
              <h3>{card.heading}</h3>
              <p>{card.paragraph}</p>
            </div>
          ))}
        </div>
        <div className="successors__down">
          <img
            className="successors__view"
            src={require("assets/images/Successors-view.webp")}
            alt=""
          />
        </div>
      </div>
      <div className="successors__fractals">
        <SuccessorsFractalSVG />
      </div>
    </section>
  );
};

export default AvailablePackages;
